import styled from 'styled-components';
import { ReactComponent as EmailSvg } from 'styles/icons/email.svg';
import { ReactComponent as ChipDeleteSvg } from 'styles/icons/chip-delete.svg';
import { color, typography, global } from 'styles/settings';
import { normalize, withModifiers } from 'utils/styles';

export const Container = styled.div`
  background-color: ${color.neutral.grayLight};
  color: ${color.neutral.plainBlack};
  ${typography.font.semiBold};
  font-size: ${typography.size.md};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 ${normalize('26px')};
  ${withModifiers('$invalid')`
    border: 2px solid ${color.ui.danger};
  `}
`;

export const EmailIcon = styled(EmailSvg)`
  margin-right: ${normalize('26px')};
  ${withModifiers('$hasChips')`
    margin-right: ${normalize('10px')};
  `}
  padding: ${normalize('23px')} 0;
`;

export const ChipContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex: 1;
  transition: height 0.4s linear;
  padding: ${normalize('23px')} 0;

  ${withModifiers('$hasChips')`
    padding: ${normalize('13px')} 0;
  `}
`;

export const Chip = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${color.brand.gold};
  color: ${color.neutral.plainBlack};
  padding: ${global.space.sm};
  padding-left: ${normalize('14px')};
  border-radius: 60px;
  cursor: default;
  margin-right: ${global.space.sm};

  ${withModifiers('withMargin')`
    margin-bottom: ${global.space.sm};
  `}

  ${withModifiers('$invalid')`
    color: ${color.neutral.white};
    background-color: ${color.ui.danger};
  `}
`;

export const ChipDelete = styled(ChipDeleteSvg)`
  justify-self: flex-end;
  margin-left: ${global.space.sm};
  cursor: pointer;
`;

export const TextInputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const TextInput = styled.input`
  border: none;
  background-color: transparent;
  color: ${color.neutral.plainBlack};
  ${typography.font.semiBold};
  font-size: ${typography.size.md};
  line-height: ${typography.size.lg};
  margin-top: -${global.space.xs};
  flex: 1;
  &:focus {
    outline: none;
  }
`;
